// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LPXz","top":"styles_top__1_Wjd","left":"styles_left__cIzKE","description":"styles_description__3_P9b"};